import { render, staticRenderFns } from "./adminChannelFirst.vue?vue&type=template&id=9a399f8e&"
import script from "./adminChannelFirst.vue?vue&type=script&lang=js&"
export * from "./adminChannelFirst.vue?vue&type=script&lang=js&"
import style0 from "./adminChannelFirst.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports